import { render } from "./MediasSection.vue?vue&type=template&id=93b1a8b2&ts=true"
import script from "./MediasSection.vue?vue&type=script&lang=ts"
export * from "./MediasSection.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__